import appConfig from 'configs/app'

const STAGING_ENVIRONMENT = 'staging'
const QA_PHONE_NUMBER_PREFIX = '+62888'

/**
 * Exempts only the proactive challenge; the backend can still demand one via
 * CAPTCHA_REQUIRED.
 */
export function isQaPhoneNumber(phoneNumber?: string): boolean {
  return (
    appConfig.environment === STAGING_ENVIRONMENT &&
    !!phoneNumber &&
    phoneNumber.startsWith(QA_PHONE_NUMBER_PREFIX)
  )
}
